"use client";
import React from "react";
import Icon from "@/components/icons/Icons";
import { useDispatch } from "react-redux";
import { openRequestCallback } from "@/redux/features/requestCallback/requestCallbackSlice";
const DisciplinedMFGuidance = () => {
  const dispatch = useDispatch();

  return (
    <section className="w-full bg-white/70 py-8 md:py-20 mb-16 md:mb-40">
      <div className="  mx-auto  max-w-165.25 px-4 md:px-0">
        <p className="text-3xl sm:text-4xl xl:text-5xl font-semibold text-[#101828] text-center mb-4 md:mb-5 ">
          Ready for Structured Mutual Fund Guidance? 
        </p>
        <p className="text-center text-[#6A7A62] text-base md:text-xl mb-6 md:mb-14  ">
          Get an unbiased second opinion on your portfolio today.
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center w-full mx-auto md:gap-8">
          <button
            onClick={() => {
              document.getElementById("mf-guidance")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            className="text-white w-full hover:text-black hover:border border transition-all duration-300  transform hover:bg-white  bg-primaryBlue py-4  flex rounded-xl gap-3 items-center justify-center mb-4 md:mb-0 max-w-82 xl:max-w-60.5">
            Get Expert Review
            <Icon.dropdownDownArrow className="-rotate-90 " />
          </button>
          <button
            onClick={() =>
              dispatch(
                openRequestCallback({
                  buttonType: "advisory_call",
                  reason: "Mutual Fund Advisory Call",
                }),
              )
            }
            className="text-[#101828] w-full transition-all duration-300  transform hover:bg-primaryBlue  hover:text-white hover:border-white border border-[#D1D5D6] rounded-xl px-8 py-4 max-w-82 xl:max-w-62.75">
            Speak With an Advisor
          </button> 
        </div>
      </div>
    </section>
  );
};

export default DisciplinedMFGuidance;
